import { createFileRoute } from '@tanstack/react-router';

import Content from '@/routes/_authenticated/hilfe/verkehrszeichen-edit.mdx';

export const Route = createFileRoute('/_authenticated/hilfe/verkehrszeichen-edit')({
  component: Content,
});
